import { Route, Redirect } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export function GatedRoute({
  path,
  redirectPath,
  isUngated,
  children
}) {
  if (!isUngated) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: redirectPath
    });
  }
  return /*#__PURE__*/_jsx(Route, {
    path: path,
    exact: true,
    children: children
  });
}